import { FetchPromotionsRequestTypes } from '../actions/PromotionActions';
import { makeRequestStatusSelector } from './RequestStatusSelectors';
export const fetchPromotionsStatus = makeRequestStatusSelector(FetchPromotionsRequestTypes.REQUEST);